export default "__VITE_ASSET__BeWniPXo__"